var map = {
	"./add.svg": "5110",
	"./admin.svg": "525e",
	"./avatar.svg": "6108",
	"./back.svg": "972b",
	"./backward.svg": "2b04",
	"./close.svg": "864a",
	"./delete.svg": "a3dd",
	"./download.svg": "039a",
	"./edit.svg": "2fb0",
	"./export.svg": "8354",
	"./forward.svg": "2163",
	"./home-selected.svg": "26a8",
	"./home.svg": "0331",
	"./info.svg": "b888",
	"./maintain.svg": "d3f7",
	"./members.svg": "178b",
	"./objective.svg": "3a5b",
	"./orders.svg": "8577",
	"./performance.svg": "f261",
	"./project.svg": "f61c",
	"./refresh.svg": "b41b",
	"./save.svg": "b7b8",
	"./statistics-selected.svg": "1656",
	"./statistics.svg": "7e06",
	"./success.svg": "ce70",
	"./task.svg": "75ca",
	"./user-selected.svg": "6295",
	"./user.svg": "d88a",
	"./view.svg": "5a17",
	"./warning.svg": "0d95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";